import USIcon from 'flag-icons/flags/4x3/us.svg';
import SpainIcon from 'flag-icons/flags/4x3/es.svg';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button.tsx';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { language } = i18n;

  const nextLang = language === 'en' ? 'es' : 'en';
  const flagIcon = getFlagIcon(nextLang);

  const handleSwitchLanguage = () => {
    if (language === 'en') {
      void i18n.changeLanguage('es');
    } else {
      void i18n.changeLanguage('en');
    }
  };

  return (
    <Button
      variant="text"
      className="flex flex-col gap-0 pt-4 pr-0 text-xs uppercase"
      onClick={handleSwitchLanguage}
    >
      {flagIcon && (
        <img
          src={flagIcon.icon}
          alt={flagIcon.alt}
          className="w-7 rounded-sm"
        />
      )}
      {nextLang}
    </Button>
  );
};

function getFlagIcon(language: string) {
  switch (language) {
    case 'en':
      return {
        icon: USIcon,
        alt: 'Spain flag',
      };
    case 'es':
      return {
        icon: SpainIcon,
        alt: 'Spain flag',
      };
    default:
      return undefined;
  }
}
